export default __webpack_public_path__ + "media/zurb/fonts/ProximaNova-Bold-09394b2afc53828fe3421d656cbe1c85.otf";